import { TableRow } from '@material-ui/core'
import React from 'react'
import { formatPrice } from '../../../util/formatters'
import { TableTitleCell } from '../../common/TableTitleCell'
import { TableValueCell } from '../../common/TableValueCell'
import { SelectedVersion } from '../../layout/VersionsSelector'
import { TotalCostsRowData } from './cost-table-types'

type Props = {
  title: string
  versions: SelectedVersion[]
  versionSums: TotalCostsRowData[]
  highlightRow?: boolean
}

export function TotalCostsTableRow(props: Props): React.ReactElement {
  const { title, versions, versionSums, highlightRow } = props

  const getVersionSum = (versionId: string) => {
    const rowData = versionSums.find(
      (versionSum) => versionSum.versionId === versionId,
    )
    if (!rowData || !rowData.sum) {
      return '-'
    }
    return formatPrice(rowData.sum, { omitUnit: true, decreasePrecision: true })
  }

  return (
    <TableRow>
      <TableTitleCell title={title} highlight={highlightRow} />
      {versions.map((version) => (
        <TableValueCell
          key={`total-header-${version.id}`}
          value={getVersionSum(version.id)}
          highlight={highlightRow}
        />
      ))}
    </TableRow>
  )
}
